<!-- app/javascript/dashboard/routes/dashboard/kanban/Index.vue -->
<template>
  <div class="p-6 min-w-0">
    <!-- Cabeçalho com busca -->
    <div class="mb-4 flex items-center justify-between gap-3">
      <div class="flex items-center gap-3 min-w-0">
        <h1 class="text-xl font-semibold whitespace-nowrap">Kanban</h1>

        <!-- Busca por nome (não interfere no DnD) -->
        <div class="relative w-64 max-w-[60vw]">
          <input
            v-model.trim="searchQuery"
            type="text"
            inputmode="search"
            placeholder="Pesquisar por nome…"
            class="w-full rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm outline-none focus:ring-2 focus:ring-blue-500 dark:bg-slate-800 dark:border-slate-700"
            @keydown.stop
          />
          <button
            v-if="hasSearch"
            type="button"
            class="absolute right-1.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
            title="Limpar"
            @click="searchQuery = ''"
          >
            ×
          </button>
        </div>
      </div>

      <div class="text-sm text-gray-500">Conta: {{ accountId }}</div>
    </div>

    <div v-if="loading" class="text-gray-500">Carregando...</div>
    <div v-else-if="error" class="text-red-600">Erro: {{ error }}</div>

    <div v-else class="h-scroll overflow-x-auto overflow-y-hidden pb-4 min-w-0" ref="kanbanWrap">
      <draggable
        v-model="board.columns"
        item-key="id"
        :animation="180"
        :direction="'horizontal'"
        :draggable="'.kanban-col.real'"
        :handle="'.col-handle'"
        :ghost-class="'col-ghost'"
        :chosen-class="'col-chosen'"
        :drag-class="'col-drag'"
        :fallback-on-body="true"
        :force-fallback="false"
        :fallback-tolerance="6"
        :swap-threshold="0.3"
        :invert-swap="true"
        @change="onColumnChange"
        @end="onColumnEnd"
        class="inline-flex flex-nowrap gap-4 px-1 w-max"
      >
        <template #item="{ element: col }">
          <!-- Wrapper continua sendo o item arrastável -->
          <div class="kanban-col real">
            <KanbanColumn
              :key="col.id || col.name"
              :column="col"
              :isVirtual="isVirtual(col)"

              :headerStyleFn="headerStyle"
              :titleColorFn="titleColor"
              :cardsBgStyleFn="cardsBgStyle"
              :onColorInputFn="onColorInput"

              :cardsDndGroupFn="cardsDndGroup"
              :cloneCardFn="cloneCard"
              :registerCardsListFn="registerCardsList"

              :onDragStartFn="onDragStart"
              :onCardMoveFn="onCardMove"
              :onCardChangeFn="onCardChange"
              :onDragEndFn="onDragEnd"

              :isDropAtFn="isDropAt"
              :onCardClickFn="onCardClick"
              :cardVisibleFn="cardVisible"
              :formatMsgTimeFn="formatMsgTime"
              :openImagePreviewFn="openImagePreview"
            />
          </div>
        </template>
      </draggable>
    </div>

    <!-- Lightbox global -->
    <ImageLightbox v-model="imagePreview.open" :url="imagePreview.url" />
  </div>
</template>

<script src="./index.script.js"></script>
<style scoped src="./index.scoped.css"></style>
